const __vite_import_meta_env__ = {};
const getColor = (context) => {
  switch (context) {
    case "success":
      return "lawngreen";
    case "error":
      return "hotpink";
    case "info":
      return "dodgerblue";
    default:
      return "white";
  }
};
const devLog = (context = "success", name, ...msg) => {
  if (!(__vite_import_meta_env__ == null ? void 0 : __vite_import_meta_env__.VITE_MODE) || (__vite_import_meta_env__ == null ? void 0 : __vite_import_meta_env__.VITE_MODE) === "development") {
    console.log(`%c${context.toUpperCase()} ${name}: `, `color: ${getColor(context)}`, ...msg);
  }
};
export {
  devLog
};
//# sourceMappingURL=devLog.js.map
